import { ErrorsEnum } from '@/api/rest/resources/types/plot';

export const getDraftPlotErrorTitleKey = (error: ErrorsEnum) => {
  const exhaustivenessCheck = (type: never) => {
    throw Error(`Unrecognised type received: ${type}`);
  };

  switch (error) {
    case ErrorsEnum.self_intersecting:
      return 'landSteward.plot.edit.plotErrorNotices.selfIntersecting.title' as const;
    case ErrorsEnum.too_small:
      return 'landSteward.plot.edit.plotErrorNotices.tooSmall.title' as const;
    case ErrorsEnum.too_large:
      return 'landSteward.plot.edit.plotErrorNotices.tooLarge.title' as const;
    case ErrorsEnum.invalid_shape_index:
      return 'landSteward.plot.edit.plotErrorNotices.invalidShapeIndex.title' as const;
    case ErrorsEnum.contains_holes:
      return 'landSteward.plot.edit.plotErrorNotices.containsHoles.title' as const;
    default:
      return exhaustivenessCheck(error);
  }
};
